const KendoPropertyNamePrefix = '$';
const KendoIdDelimiter = '_';
const StandardIdDelimiter = '-';

export const KendoTreelistUtil = {
    toKendoFieldName(columnId: string): string {
        return `${KendoPropertyNamePrefix}${columnId.replace(new RegExp(StandardIdDelimiter, 'g'), KendoIdDelimiter)}`;
    },
    toColumnId(kendoFieldName: string): string {
        return kendoFieldName.startsWith(KendoPropertyNamePrefix) ? kendoFieldName.slice(1).replace(new RegExp(KendoIdDelimiter, 'g'), StandardIdDelimiter) : kendoFieldName;
    },
};
